import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import * as FileSaver from 'file-saver';
import { selectTanksOperations, selectTanksOperationsFilter } from '../../../state/selectors/tanks.js';
import tankService from '../../../services/tanksService.js';
import { createStructuredSelector } from 'reselect';
import { useLocalization } from '../../../hooks/useLocalization.js';
import Table from '../../../components/table/table.jsx';
import Loader from '../../../components/loader/loader.jsx';

const Columns = [
    {
        header: "TankOperation.userName",
        name: "userName",
        dataType: "text"
    },
    {
        header: "TankOperation.tankName",
        name: "tankName"
    },
    {
        header: "TankOperation.fuelType",
        name: "fuelType"
    },
    {
        header: "TankOperation.provider",
        name: "provider"
    },
    {
        header: "TankOperation.description",
        name: "description"
    },
    {
        header: "TankOperation.balance",
        name: "balance",
        dataType: "float"
    },
    {
        header: "TankOperation.deliveryDate",
        name: "deliveryDate",
        dataType: "datetime"
    },
    {
        header: "TankOperation.completed",
        name: "completed",
        dataType: "boolean"
    }
];


const TanksOperationsList = (props) => {
    const { operations, filter } = props;
    const [loading, setLoading] = useState(false);
    const {t} = useLocalization();

    useEffect(() => {
        getData();
    }, []);

    const getData = async (filt) => {
        filt = filt ? filt : filter;
        setLoading(true);
        await tankService.getTanksOperationsAsync(filt);
        setLoading(false);
    }

    const getReport = async (filter) => {
        const data = await tankService.getOperationsReportAsync(filter);
        if (data) {
            FileSaver.saveAs(data, 'tanks_operations.xlsx');
        };
    }

    const modelFilter = {
        tankName: {
            name: "tankName",
            type: "string",
            header: t('TanksOperations.Filter.tankName'),
            value: filter.modelFilter.tankName
        },
        dateTime: {
            name: "dateTime",
            type: "dates",
            dateFrom: {
                name: "dateFrom",
                header: t("TanksOperations.Filter.dateFrom"),
                value: filter.modelFilter.dateFrom
            },
            dateTo: {
                name: "dateTo",
                header: t("TanksOperations.Filter.dateTo"),
                value: filter.modelFilter.dateTo
            }
        }
    };

    return (
        <div>
            <Table settings={{
                columns: Columns,
                items: operations,
                itemsFilter: Object.assign({}, filter, { filterProps: modelFilter }),
                isEditable: false,
                getItemsFunction: getData,
                getReportFunction: getReport
            }} />
            {loading && <Loader />}
        </div>
    );

}

const mapStateToProps = () => {
    return createStructuredSelector({
        operations: selectTanksOperations(),
        filter: selectTanksOperationsFilter()
    });
}

export default connect(mapStateToProps)(TanksOperationsList);